import axios from '@fuse/utils/axios';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup'
import { FormControl, makeStyles } from '@material-ui/core';
import React, { useState, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import useToast from '@fuse/hooks/useToast';
import { Autocomplete } from '@material-ui/lab';
// import LocationTypeDialog from './QuickAddLocationType';
import { Box, Button, DialogTitle, TextField, Typography, Grid, Dialog, DialogContent, DialogActions } from '@mui/material'
import AlphabeticalSorting from '@fuse/utils/alphabeticalSort';
import { usePermission } from '@fuse/hooks';
import { generateProperLocationString } from '@fuse/utils/general';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}))


const RestoreArchiveModal = ({
    handleOpenCloseAddModalEvent,
    openAddStatusModalStateData,
    handleSave
}) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const toast = useToast(dispatch)
    const [statusMenu, setStatusMenu] = useState([]);
    const [locationMenu, setLocationMenu] = useState([])
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);
    const { hasPermission } = usePermission()
    const addAssetStatusPermission = hasPermission('add-asset_status');
    const defaultValues = {
        status: null,
        location: null,
    };
    const validationSchema = [

        yup.object({
            status: yup.object().shape({
                id: yup.string().required('Status is required.'),
                label: yup.string().required('Status is required.')
            }).required('Status is required!'),
            location: yup.object().shape({
                id: yup.number().required('Location is required.'),
                entity_external_platform_id: yup.string().required('Status is required.'),
                location_name: yup.string().required('Location is required.'),
                address1: yup.string().required('Location is required.'),
                // address2: yup.string().required('Location is required.'),
                city: yup.string().required('Location is required.'),
                country: yup.string().required('Location is required.'),
                state: yup.string().required('Location is required.'),
                // zip: yup.string().required('Location is required.'),
            }).required('Location is required.'),
        }),

    ];
    const currentValidationSchema = validationSchema[0];

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(currentValidationSchema),
        mode: "onChange"
    });

    const { control, formState, handleSubmit, reset, setValue, clearErrors, getValues, trigger } = methods
    const { errors } = formState

    const fetchLocationSuggestions = (value = '') => {
        setLoading(true)
        axios.get(`assets/fetch-location-suggestion?value=${value}`).then(response => {
            let locations = AlphabeticalSorting(response.data.data.locations, 'location_name')
            setLoading(false)
            setLocationMenu(locations)
        }).catch(err => {
            console.log('136=>', err);
        })
    }

    const fetchStatus = () => {
        axios.get(`asset-status?type=hardware`).then(response => {
            let status = AlphabeticalSorting(response.data.data, 'status_name')
            setStatusMenu(status.map((item) => {
                return {
                    id: item.id,
                    label: item.status_name
                }
            }))
        }).catch(err => {
            console.log('136=>', err);
        })
    }


    useEffect(() => {
        fetchStatus()
        fetchLocationSuggestions()
    }, [])

    const onSubmit = (data) => {
        let payload = {
            location_id: Number(data?.location?.id),
            status_id: Number(data.status.id),
        }
        handleSave(payload)
        handleOpenCloseAddModalEvent()
    }

    return (
        <>
            <Dialog
                className="cstm_dialog_modal small text-center"
                open={openAddStatusModalStateData}
                onClose={handleOpenCloseAddModalEvent}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <div className='heading_holder flexbox_holder items-center w-full'>
                        <h2 className="main_heading">Update Location and Status</h2>
                        <Button className='transparent_icon_btn' onClick={handleOpenCloseAddModalEvent}>
                            <i className="icon ti ti-x" />
                        </Button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div className="text-left">
                        <div className='mb-10'>
                            <Grid item xs={12}>
                                <Box>
                                    <Typography className='status_text'>
                                        Status
                                        <span className='required_span'>*</span>
                                    </Typography>
                                    <FormControl fullWidth className='assets_listSelect'>
                                        <Controller
                                            name="status"
                                            className="mb-16"
                                            control={control}
                                            render={({ field: { ref, ...field } }) => (
                                                <>
                                                    <Autocomplete
                                                        {...field}
                                                        style={{ width: '100%' }}
                                                        className='main_autocomplete'
                                                        options={statusMenu}
                                                        // disablePortal
                                                        onChange={(event, value) => field.onChange(value)}
                                                        // PaperComponent={({ children }) => (
                                                        //     <Paper className='autocomplete_holder'>{children}
                                                        //         {addAssetStatusPermission && <div className='p-16'>
                                                        //             <Button className='secondary_btn w-full' onMouseDown={() => handleOpenCloseAddStatus()}>
                                                        //                 <i className='ti ti-plus' />
                                                        //                 <span>Add Status</span>
                                                        //             </Button>
                                                        //         </div>}
                                                        //     </Paper>
                                                        // )}
                                                        getOptionLabel={option => option.label ?? ''}
                                                        renderInput={(params) => {
                                                            return (
                                                                <div ref={params.InputProps.ref}>
                                                                    <TextField
                                                                        name="status"
                                                                        style={{ background: 'white' }}
                                                                        {...params}
                                                                        // label="Status"
                                                                        required
                                                                        defaultValue={defaultValues.status}
                                                                        error={!!errors.status?.id}
                                                                        helperText={errors?.status?.message && 'Status is required!'}
                                                                        FormHelperTextProps={{
                                                                            style: {
                                                                                margin: 0,
                                                                                backgroundColor: '#f4f4f4',
                                                                                width: '100%',
                                                                                paddingTop: '2px',
                                                                                fontSize: '10px',
                                                                                color: '#FF0000'
                                                                            }
                                                                        }}
                                                                        variant="outlined"
                                                                        fullWidth
                                                                    />
                                                                </div>
                                                            )
                                                        }}
                                                    />
                                                </>
                                            )}
                                        />
                                    </FormControl>
                                </Box>
                            </Grid>
                        </div>

                        <div className='mb-10'>
                            <Grid item xs={12}>
                                <Box>
                                    <Typography className='status_text'>
                                        Location
                                        <span className='required_span'>*</span>
                                    </Typography>
                                    <FormControl fullWidth className='assets_listSelect'>
                                        <Controller
                                            name="location"
                                            className="mb-16"
                                            control={control}
                                            render={({ field: { ref, ...field } }) => (
                                                <>

                                                    <Autocomplete
                                                        {...field}
                                                        style={{ width: '100%' }}
                                                        className='main_autocomplete'
                                                        options={locationMenu}
                                                        // disablePortal
                                                        onChange={(event, value) => field.onChange(value)}
                                                        // PaperComponent={({ children }) => (
                                                        //     <Paper className='autocomplete_holder'>{children}
                                                        //         {addLocationPermission && <div className='p-16'>
                                                        //             <Button className='secondary_btn w-full' onMouseDown={() => handleOpenCloseAddLocation()}>
                                                        //                 <i className='ti ti-plus' />
                                                        //                 <span>Add Location</span>
                                                        //             </Button>
                                                        //         </div>}
                                                        //     </Paper>
                                                        // )}
                                                        getOptionLabel={
                                                            option => {
                                                                return generateProperLocationString({
                                                                    location_name: option?.location_name ?? '',
                                                                    address1: option?.address1 ?? '',
                                                                    address2: option?.address2 ?? '',
                                                                    city: option?.city ?? '',
                                                                    state: option?.state ?? '',
                                                                    country: option?.country ?? ''
                                                                })
                                                            }
                                                        }
                                                        renderInput={(params) => {
                                                            return (
                                                                <div ref={params.InputProps.ref}>
                                                                    <TextField
                                                                        {...params}
                                                                        style={{ background: 'white' }}
                                                                        // label="Location"
                                                                        required
                                                                        defaultValue={defaultValues.location}
                                                                        error={!!errors?.location}
                                                                        helperText={errors?.location?.message && "Location is required."}
                                                                        FormHelperTextProps={{
                                                                            style: {
                                                                                margin: 0,
                                                                                backgroundColor: '#f4f4f4',
                                                                                width: '100%',
                                                                                paddingTop: '2px',
                                                                                fontSize: '10px'
                                                                            }
                                                                        }}
                                                                        variant="outlined"
                                                                        fullWidth
                                                                    />
                                                                </div>
                                                            )
                                                        }}
                                                    />
                                                </>
                                            )}

                                        />
                                    </FormControl>
                                </Box>
                            </Grid>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="action_footer_holder">
                    <Button onClick={handleOpenCloseAddModalEvent} className="secondary_btn">Cancel</Button>
                    <Button onClick={handleSubmit(onSubmit)} className="primary_btn">
                        Save
                    </Button>
                </DialogActions>

            </Dialog>
        </>
    );

}


export default RestoreArchiveModal;